'use client';

import { useEffect } from 'react';
import { Button, Signage } from '@kcd/design-system';

import { logError } from '~/utils/datadog';

import '~/styles/global.css';
import '@kcd/design-system/dist/feather.css';
import '@kcd/design-system/ssr/index.css';

type Props = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function GlobalError({ error, reset }: Props) {
  useEffect(() => {
    logError(error);
  }, [error]);

  return (
    <html lang="ko">
      <body>
        <Signage
          verticalCenter
          title="일시적인 오류가 발생했습니다."
          action={
            <Button size="sm" variant="outline" onClick={reset}>
              캐시노트 마켓 홈으로 이동
            </Button>
          }
        />
      </body>
    </html>
  );
}
